const ua = navigator.userAgent;

export const isSupportedBrowser = (): boolean => {
  // ChromiumベースのEdge・Opera・Samsung等を除外し、純粋なChromeのみ許可
  const isEdge = /Edg\//.test(ua);
  const isOpera = /OPR\//.test(ua);
  const isSamsungBrowser = /SamsungBrowser\//.test(ua);
  // BraveはプライバシーのためUAをChromeと完全に同一に偽装しており、UA文字列だけでは判別できない。
  // navigator.brave はBraveのみが公開する専用プロパティなのでこれで判定する。
  const isBrave = !!(navigator as any).brave;
  const isChrome = /Chrome\//.test(ua) && !isEdge && !isOpera && !isSamsungBrowser && !isBrave;
  return isChrome;
};
